<hbo-datatable-smart *ngIf="entities$ | async as entities" [columns]="columns" [items]="entities"
  (reload)="searchEntities($event)" [typeData]="'entitiesList'"
  [showTeamFilter]="user.roleId === 1 || user.roleId === 2"
  [teams_filter]="teams">
  <tbody class="table-group-divider accordion" id="accordionEntity">
    <ng-container *ngFor="let entity of entitiesCollection$">
      <tr class="accordion-header">
        <th scope="row"><button class="accordion-button collapsed" data-bs-toggle="collapse"
            [attr.data-bs-target]="'#collapse-' + entity.id"> </button></th>
        <td>{{ entity.id }}</td>
        <td>{{ entity.name }}</td>
        <td>{{ entity.entityType?.name }}</td>
        <td>{{ entity.identityCode }}</td>
        <td>{{ entity.parentEntity?.name }}</td>
        <td>{{ entity.contact }}</td>
        <td *ngIf="columns.includes('horizonsTeam')">{{ entity.entityTypeId === 2 ? entity.horizonsTeam?.name : '-'}}
        </td>
        <td *ngIf="columns.includes('team')">{{ (entity.entityTypeId > 2 && entity.calculatedTeamName) || '-'}}</td>
      </tr>
      <tr class="row-body">
        <td [attr.colspan]="user.roleId === 1 ? 9 : user.roleId === 2 ? 8 : 7" class="bg-light p-0">
          <div [id]="'collapse-' + entity.id" class="accordion-collapse collapse" data-bs-parent="#accordionEntity">
            <div class="accordion-body">
              <hbo-entity-actions [entity]="entity" (reload)="searchEntities()"
                [selectorVisible]="openedRow === 'collapse-' + entity.id"
                (callback)="callback($event)"></hbo-entity-actions>
            </div>
          </div>
        </td>
      </tr>
    </ng-container>
    <tr *ngIf="!entities.data?.length">
      <td colspan="6" class="text-center">{{ 'COMMON.NO_RESULTS' | translate }}</td>
    </tr>
  </tbody>
</hbo-datatable-smart>